var _desc, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPosition3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10 by 10 orthogonal maze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "10 by 10 orthogonal maze generated by The Maze Generator Website (https://www.mazegenerator.net/).")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 81.372,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 2,
    x2: 162,
    y2: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.251 17.999 L 98 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 18,
    x2: 146,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 34,
    x2: 130,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 34,
    x2: 162,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.024,
    y1: 66.031,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 50,
    x2: 146,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 66,
    x2: 114,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 66,
    x2: 162,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.856,
    y1: 81.972,
    x2: 66,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 82,
    x2: 98,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 82,
    x2: 146,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 98,
    x2: 82,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 98,
    x2: 114,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 98,
    x2: 146,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.934,
    y1: 113.94,
    x2: 34.027,
    y2: 114.008
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 114,
    x2: 98,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 130,
    x2: 82,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 130,
    x2: 162,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 146,
    x2: 66,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 146,
    x2: 146,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 162,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.274,
    y1: 162.065,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 2.226,
    y2: 145.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 2,
    x2: 18,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 50,
    x2: 18,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.096,
    y1: 97.669,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.957,
    y1: 130.903,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 18,
    x2: 34,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 34,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 114,
    x2: 34,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.931,
    y1: 18.04,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 82,
    x2: 49.919,
    y2: 129.867
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 18,
    x2: 66,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 66,
    x2: 82,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 98,
    x2: 82,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 130,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 82,
    x2: 98,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 114,
    x2: 98,
    y2: 146
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.971 17.972 C 113.971 23.838 114.023 40.713 114.023 30.847"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 66,
    x2: 114,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 98,
    x2: 114,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 34,
    x2: 130,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 114,
    x2: 130,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 82,
    x2: 146,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.517,
    y1: 17.603,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.217,
    y1: 114.135,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.353,
    y1: 145.094,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 18.107,
    y2: 81.925
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.85,
    y1: 34.067,
    x2: 18,
    y2: 34
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03019, 0, 0, 0.028854, -0.346778, 143.257126)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 1371.73 -338.083 C 1388.246 -336.745 1402.553 -349.016 1403.89 -365.475 C 1405.169 -381.933 1392.898 -396.239 1376.382 -397.635 C 1360.04 -398.856 1345.618 -386.585 1344.396 -370.127 C 1343 -353.785 1355.271 -339.363 1371.729 -338.083"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 1346.43 -325.813 C 1352.304 -329.942 1359.457 -332.675 1367.424 -331.977 C 1377.66 -331.163 1386.034 -324.824 1391.152 -317.089 L 1421.277 -257.363 L 1462.393 -229.041 C 1465.882 -226.366 1468.092 -222.005 1467.627 -217.235 C 1467.045 -209.85 1460.59 -204.324 1453.204 -204.964 C 1450.936 -205.081 1449.075 -206.011 1447.039 -206.942 L 1402.201 -237.823 C 1400.806 -238.928 1399.701 -240.323 1398.77 -241.777 L 1387.546 -264.167 L 1373.996 -204.615 L 1426.976 -142.039 C 1428.197 -140.12 1429.012 -137.852 1429.477 -135.584 L 1443.783 -60.039 C 1443.667 -58.353 1443.899 -57.306 1443.783 -55.968 C 1442.969 -44.686 1433.199 -36.544 1422.091 -37.358 C 1412.844 -38.114 1406.04 -44.918 1403.888 -53.351 L 1390.396 -124.127 L 1347.302 -171.233 L 1337.357 -125.348 C 1337.008 -123.196 1334.159 -118.66 1333.344 -116.857 L 1291.995 -47.186 C 1287.924 -40.847 1281.003 -36.776 1273.153 -37.416 C 1261.929 -38.23 1253.613 -48 1254.543 -59.166 C 1254.776 -62.307 1256.114 -65.621 1257.277 -67.89 L 1295.66 -132.269 L 1327.704 -274.169 L 1306.768 -257.246 L 1295.66 -206.708 C 1294.148 -200.194 1288.274 -194.902 1281.354 -195.426 C 1273.852 -196.007 1268.385 -202.462 1268.967 -209.965 C 1268.967 -210.546 1269.083 -211.128 1269.199 -211.826 L 1282.342 -270.738 C 1283.156 -273.238 1284.494 -275.506 1286.471 -277.251 L 1346.43 -325.811 L 1346.43 -325.813 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition3);
export default __webpack_public_path__ + "static/media/Position3.91dd65f7abc655ec3ca3f4784abb8bf0.svg";
export { ForwardRef as ReactComponent };